import { render, staticRenderFns } from "./PbFloatButton.vue?vue&type=template&id=fce2ea7c&"
import script from "./PbFloatButton.vue?vue&type=script&lang=js&"
export * from "./PbFloatButton.vue?vue&type=script&lang=js&"
import style0 from "./PbFloatButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports